import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_WORKGROUP,
  DELETE_WORKGROUP,
  UPDATE_WORKGROUP,
  ADD_NEW_WORKGROUP,
} from "./actionType";

import {
  getWorkGroupSuccess,
  getWorkGroupFail,
  deleteWorkGroupSuccess,
  deleteWorkGroupFail,
  updateWorkGroupSuccess,
  updateWorkGroupFail,
  addWorkGroupSuccess,
  addWorkGroupFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveWorkGroupApi,
  getWorkGroupApi,
  updateWorkGroupApi,
  deleteWorkGroupApi,
  addNewWorkGroupApi
} from "../../helpers/backend_helper";

function* getWorkGroup({ payload: workGroup }) {
  try {
    const response = yield call(getWorkGroupApi, workGroup);
    yield put(getWorkGroupSuccess(GET_WORKGROUP, response.data));
  } catch (error) {
    yield put(getWorkGroupFail(GET_WORKGROUP, error));
  }
}

function* onUpdateWorkGroup({ payload: workGroup }) {
  try {
    if (workGroup.setApprove) {
      const response = yield call(approveWorkGroupApi, workGroup);
      yield put(updateWorkGroupSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateWorkGroupApi, workGroup);
      yield put(updateWorkGroupSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateWorkGroupFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteWorkGroup({ payload: workGroup }) {
  try {
    const response = yield call(deleteWorkGroupApi, workGroup);
    yield put(deleteWorkGroupSuccess({ workGroup, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteWorkGroupFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewWorkGroup({ payload: workGroup }) {
  try {
    const response = yield call(addNewWorkGroupApi, workGroup);
    yield put(addWorkGroupSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addWorkGroupFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetWorkGroup() {
  yield takeEvery(GET_WORKGROUP, getWorkGroup);
}

export function* watchUpdateWorkGroup() {
  yield takeEvery(UPDATE_WORKGROUP, onUpdateWorkGroup);
}

export function* watchDeleteWorkGroup() {
  yield takeEvery(DELETE_WORKGROUP, onDeleteWorkGroup);
}

export function* watchAddNewWorkGroup() {
  yield takeEvery(ADD_NEW_WORKGROUP, onAddNewWorkGroup);
}

function* workGroupSaga() {
  yield all([
    fork(watchGetWorkGroup),
    fork(watchDeleteWorkGroup),
    fork(watchUpdateWorkGroup),
    fork(watchAddNewWorkGroup)
  ]);
}

export default workGroupSaga;
